

























import { Component, Prop, Vue } from 'vue-property-decorator'

import BookingExtra, {
  BookingExtraTypes,
  BookingExtraValueTypes,
} from '@/models/booking-extra'

@Component
export default class BookingExtras extends Vue {
  @Prop() bookingExtras!: BookingExtra[]
  @Prop() currencyCode!: string

  bookingExtraValueTypes = BookingExtraValueTypes

  get bookingExtrasOrdered() {
    const a = this.$_.orderBy(this.bookingExtras, [
      (e) => e.extraType === BookingExtraTypes.Extra,
      (e) => e.valueType === BookingExtraValueTypes.Fixed,
      (e) => e.amountCents,
    ])

    return a
  }

  getExtraType(bookingExtra: BookingExtra): string {
    return bookingExtra.amountCents < 0 ? 'Discount' : 'Extra'
  }
}
